const importers = {
        './src/SimilarCandidates/SimilarCandidates.stories.ts': async () => import('/@fs//source/src/SimilarCandidates/SimilarCandidates.stories.ts'),
  './src/MatchingCandidates/MatchingCandidates.stories.ts': async () => import('/@fs//source/src/MatchingCandidates/MatchingCandidates.stories.ts'),
  './src/Buttons/ViewSeekProfile/ViewSeekProfile.stories.ts': async () => import('/@fs//source/src/Buttons/ViewSeekProfile/ViewSeekProfile.stories.ts'),
  './src/Buttons/TalentSearch/TalentSearch.stories.ts': async () => import('/@fs//source/src/Buttons/TalentSearch/TalentSearch.stories.ts'),
  './src/Buttons/SignInOut/SignInOut.stories.ts': async () => import('/@fs//source/src/Buttons/SignInOut/SignInOut.stories.ts')
    };

    export async function importFn(path) {
        return importers[path]();
    }